import React, { useEffect, useState, useContext } from "react";
import { Link } from "react-router-dom";

import FavoritesContext from "contexts/FavoritesContext";
import RecipeRating from "components/RecipeRating";
import ShareSocial from "components/ShareSocial";

import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Card from "@mui/material/Card";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import CardActionArea from "@mui/material/CardActionArea";
import CardActions from "@mui/material/CardActions";
import IconButton from "@mui/material/IconButton";
import TimerIcon from "@mui/icons-material/Timer";
import PeopleIcon from "@mui/icons-material/People";
import SpeedIcon from "@mui/icons-material/Speed";
import FavoriteIcon from "@mui/icons-material/Favorite";

function RecipeCard({ recipe }) {
  // "contextFavItems" variable used to consume/use Favorites context
  // "setContextFavItems" variable used to provide/update Favorites context
  const [contextFavItems, setContextFavItems] = useContext(FavoritesContext);
  
  // Define initial state
  const [isFavorited, setIsFavorited] = useState(false);

  // Define variables to display recipe details
  const recipeID = recipe.id;
  const recipeURL = "/recipes/" + recipeID;
  const imageURL = recipe.image;
  const name = recipe.name;
  const time = (recipe.prepTimeMinutes + recipe.cookTimeMinutes) + " Mins";
  const servings = recipe.servings + " Servings";
  const difficulty = recipe.difficulty;
  const rating = recipe.rating;
  
  const handleFavItem = function(event) {
    if (!isFavorited) {
      setContextFavItems([...contextFavItems, recipeID]); // provide/update Favorites context by adding favorited item recipeID to array
    } else {
      const updatedFavItemsArray = contextFavItems.filter((item) => item !== recipeID);
      setContextFavItems(updatedFavItemsArray);  // provide/update Favorites context by removing favorited item recipeID from array
    }
  };

  useEffect(() => {
    if (contextFavItems.includes(recipeID)) {
      setIsFavorited(true);
    } else {
      setIsFavorited(false);
    }
  }, [contextFavItems, recipeID]);

  return (
    <>
      <Card sx={{ maxWidth: 345 }}>
        <CardActionArea component={Link} to={recipeURL}>
          <CardMedia component="img" height="250" image={imageURL} alt={name} />
          <CardContent>
            <Typography component="div" gutterBottom noWrap variant="h5">
              {name}
            </Typography>
            <Stack direction="row" spacing={3}>
              <Stack direction="row" alignItems="center" spacing={0.5}>
                <TimerIcon fontSize="small" color="info" />
                <Typography variant="body2" color="text.secondary">
                  {time}
                </Typography>
              </Stack>
              <Stack direction="row" alignItems="center" spacing={0.5}>
                <PeopleIcon fontSize="small" color="info" />
                <Typography variant="body2" color="text.secondary">
                  {servings}
                </Typography>
              </Stack>
              <Stack direction="row" alignItems="center" spacing={0.5}>
                <SpeedIcon fontSize="small" color="info" />
                <Typography variant="body2" color="text.secondary">
                  {difficulty}
                </Typography>
              </Stack>
            </Stack>
            {/* RecipeRating component */}
            <RecipeRating rating={rating} />
          </CardContent>
        </CardActionArea>
        <CardActions disableSpacing>
          <IconButton aria-label="Add to Favorites" onClick={handleFavItem}>
          {isFavorited ? (
            <>
              <FavoriteIcon sx={{ color: "red" }} />
            </>
          ) : (
            <>
              <FavoriteIcon color="action" />
            </>
          )}
          </IconButton>
          {/* ShareSocial component */}
          <ShareSocial recipeURL={recipeURL} imageURL={imageURL} name={name} />
        </CardActions>
      </Card>
    </>
  );
}

export default RecipeCard;